<template>
  <!-- Widget -->
  <div>
    <h2>{{ customization.title || $t('customize_this_title') }}</h2>
    <hr class="w-100">
  </div>
</template>

<script>
export default {
  props: {
    widget: {
      type: Object
    },
    customization: {
      type: Object
    }
  },
  data () {
    return {
    }
  }
}
</script>
